import web from "@/core/middlewares/web";
let referral = () => import(/* webpackChunkName: "referral" */ '@/views/referral/Index');

export default [
    {
        path: "referral",
        name: "referral",
        component: referral,
        meta: {
            middleware: web,
            title: "کسب درآمد"
        }
    },
]